<template>
    <ConfigProvider :locale="configProviderLocale">
        <Spin class="app-spinner" :spinning="isLoading">
            <Layout :class="{ 'min-h-100vh': stateAppLayout.isLayout }">
                <router-view></router-view>
                <template v-for="modal in state.modals" :key="modal.id">
                    <Modal v-bind="modal.bind">
                        <component :is="modal.render"></component>
                    </Modal>
                </template>
            </Layout>
        </Spin>
    </ConfigProvider>
</template>

<script>
import { computed, defineComponent } from "vue";
import { ConfigProvider, Layout, Spin, Modal } from "ant-design-vue";
import { state, isLoading, getConfigProviderLocale } from "./app.logic";
import { state as stateAppLayout } from "./components/layout/app-layout/app-layout.logic";

export default defineComponent({
    components: {
        ConfigProvider,
        Layout,
        Spin,
        Modal
    },
    setup() {
        const configProviderLocale = computed(() => getConfigProviderLocale());
        return { state, isLoading, configProviderLocale, stateAppLayout };
    }
});
</script>

<style>
@import "./assets/css/custom.css";

.app-spinner {
    z-index: 1000000 !important;
    position: fixed !important;
    max-height: 100% !important;
}
</style>
